import { FC } from "react";
import { Stack, Tabs, Tab } from "@mui/material";
import { CollectionsTable } from "./CollectionsTable/CollectionsTable";
import { CollectionsFilters } from "./CollectionsActions/CollectionsFilters";
import { CollectionsCreateButton } from "./CollectionsActions/CollectionsCreateButton";
import {
  WithCollectionsContext,
  useCollectionsContext,
} from "./hooks/useCollectionsContext";
import { CollectionDialog } from "./CollectionDialog/CollectionDialog";
import type { CollectionFilterBy } from "../../../apis/bacchus/collections";

const CollectionsViewContent: FC = () => {
  const { filterBy, changeFilterBy } = useCollectionsContext();

  const handleTabChange = (
    _: React.SyntheticEvent,
    newValue: CollectionFilterBy
  ) => {
    changeFilterBy(newValue);
  };

  return (
    <Stack spacing={3}>
      <Tabs
        value={filterBy}
        onChange={handleTabChange}
        data-testid="collections-filter-tabs"
        sx={{ borderBottom: 1, borderColor: "divider", mt: 3 }}
      >
        <Tab
          label="My Collections"
          value="owned"
          data-testid="collections-tab-my"
        />
        <Tab
          label="Shared Collections"
          value="shared"
          data-testid="collections-tab-shared"
        />
      </Tabs>

      <Stack direction="row" justifyContent="space-between">
        <CollectionsFilters />
        {filterBy === "owned" && <CollectionsCreateButton />}
      </Stack>

      <CollectionsTable />
    </Stack>
  );
};

export const CollectionsView: FC = () => {
  return (
    <WithCollectionsContext>
      <CollectionsViewContent />
      <CollectionDialog />
    </WithCollectionsContext>
  );
};
